<template>
  <div>
    <div><b>Organization Name:</b> {{ item.organizationName }}</div>
    <div><b>Physician Group Type:</b> {{ item.physicianGroupType }}</div>
    <div><b>Main Specialty:</b> {{ item.physicianGroupMainSpecialty }}</div>
    <div><b>City:</b> {{ item.physicianGroupCity }}</div>
    <div><b>State:</b> {{ item.physicianGroupState }}</div>
    <div><b>Territory Name:</b> {{ item.oasTerritoryName }}</div>
    <div><b>Segment Type:</b> {{ item.additionalData.SEGMENT_TYPE }}</div>
    <div><b>Tier Target Flag:</b> {{ item.additionalData.TIER_TARGET_FLAG_Y_N }}</div>
    <div><b>Call Frequency:</b> {{ item.callFrequency }}</div>
  </div>
</template>

<script>
import { tryParse } from '../../libraries/common'
export default {
  props: ['item'],
  computed: {
    additionalData() {
      return tryParse(this.item.additionalData);
    },
  },
}
</script>